<script setup lang="ts">
import IconMdiLoading from '~icons/mdi/loading';

interface Props {
	size?: 'sm' | 'md';
}

withDefaults(defineProps<Props>(), {
	size: 'md'
});

const sizeClasses = {
	sm: 'size-4',
	md: 'size-5'
} as const;

const iconSizeClasses = {
	sm: 'size-2',
	md: 'size-3'
} as const;
</script>

<template>
	<span
		:class="[
			'flex items-center justify-center rounded-full bg-primary-light-3',
			sizeClasses[size]
		]"
		aria-label="Loading"
		role="status"
		data-testid="loading-badge"
	>
		<IconMdiLoading
			:class="['animate-spin text-white', iconSizeClasses[size]]"
			aria-hidden="true"
		/>
	</span>
</template>
